import React,{ Component } from "react";

export const HeartSvg = () => (
    <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
        <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z" />
    </svg>
);


export const DownLoad = () => (
    <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <title>download-outlined</title>
        <g id="资源管理" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="单位资源-图片" transform="translate(-600.000000, -464.000000)" fill-rule="nonzero">
                <g id="编组-20" transform="translate(448.000000, 383.000000)">
                    <g id="编组-44" transform="translate(0.000000, 79.000000)">
                        <g id="download-outlined" transform="translate(152.000000, 2.000000)">
                            <rect id="矩形" fill="#000000" opacity="0" x="0" y="0" width="16" height="16"></rect>
                            <path d="M7.68504245,13.9023955 C7.84502089,14.0325348 8.15497911,14.0325348 8.31495755,13.9023955 L13.9142028,9.40465209 C14.1191752,9.23959728 13.9342001,8.99518921 13.5992452,8.99518921 L9.8947446,8.99518921 L9.8947446,3.25393047 C9.8947446,3.11426871 9.71476886,3 9.49479851,3 L6.49520284,3 C6.27523249,3 6.09525675,3.11426871 6.09525675,3.25393047 L6.09525675,8.99201508 L2.40075476,8.99201508 C2.06579991,8.99201508 1.88082484,9.23642315 2.08579721,9.40147795 L7.68504245,13.9023955 Z" id="形状" fill="#FFFFFF"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
